import React, { useEffect, useState } from "react";
import Button from "../../../components/Buttons/Button";
import DataTable from "../../../components/DataTable/DataTable";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import ProductCategoryModel from "../../../models/ProductCategoryModel";
import ProductCategoryReferenceModel from "../../../models/ProductCategoryReferenceModel";
import DataService from "../../../services/data.service";
import { PopupProps } from "../../../types/PopupProps";
import { Result } from "../../../types/Result";

interface ExportModel {
    productCategoryId: number
    productCategoryReferences: ProductCategoryReferenceModel[]
}
interface IProps extends PopupProps {
    productCategory: ProductCategoryModel
}

const ExportProductCategoryPopup: React.FC<IProps> = ({ show, onHide, productCategory }) => {
    const { handleResult, handleException } = useNotifications();
    const [data, setData] = useState<ExportModel>();

    useEffect(() => {
        getData()
    }, [productCategory]);

    function getData() {
        if (productCategory) {
            DataService.get<ProductCategoryReferenceModel[]>('api/v1/ProductCategoryReferences/ByProductCategory/' + productCategory.id)
                .then(response => {
                    setData({
                        productCategoryId: productCategory.id,
                        productCategoryReferences: response
                    })
                })
        }
    }

    function submit() {
        if (data) {
            data.productCategoryReferences = data.productCategoryReferences.filter(x => x['_checkbox_export'] === true)
            DataService
                .post<Result>(`api/v1/ProductCategoryReferences/export`, data)
                .then(response => {
                    handleResult(response);
                    if (response.isSuccesful === true)
                        onHide();
                    else
                        getData();
                })
                .catch(e => handleException(e));
        }
    }

    function selectAllRows(selectedRows: any[]) {
        if (data) {
            if (selectedRows.length != data.productCategoryReferences.length)
                data.productCategoryReferences.forEach(r => r['_checkbox_export'] = true)
            else
                data.productCategoryReferences.forEach(r => r['_checkbox_export'] = false)

            setData(x => ({ ...data }))
        }
    }


    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Export product category'} >
            <Popup.Body>
                {data && (
                    <DataTable
                        name='dtProductCategoryExport'
                        colInfos={[
                            { key: true, dataProp: 'id', visible: false },
                            { checkboxButton: { icon: 'fa-check', color: 'green', text: 'export', onClick: (selectedRows) => { selectAllRows(selectedRows); } } },
                            { title: 'External System', dataProp: 'externalSystemName' },
                            { title: 'Reference code', dataProp: 'referenceCode' },
                            { title: 'Ready on', dataProp: 'readyForExportOn', dataType: 'datetime' },
                            { title: 'Exported on', dataProp: 'exportedOn', dataType: 'datetime' },
                        ]}
                        tableData={data.productCategoryReferences}
                    />
                )}
            </Popup.Body>
            <Popup.Footer>
                <Button text="Export" type='button' onClick={submit} />
            </Popup.Footer>
        </Popup>
    );
}
export default ExportProductCategoryPopup;